module.exports = __webpack_public_path__ + "6bd8e3610dc01f6279dd2732b0ef3ad2.fbx";